import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'wl-devices-settings',
    template: `
        <div class="gutter-padding">
            <h2>{{ 'GLOBAL.SETTINGS.DEVICES.TITLE' | translate }}</h2>
            <abs-devices></abs-devices>
        </div>
    `
})
export class DevicesSettingsPage {}
